import { render, staticRenderFns } from "./summary.vue?vue&type=template&id=0a16aafa&scoped=true&"
import script from "./summary.vue?vue&type=script&lang=ts&"
export * from "./summary.vue?vue&type=script&lang=ts&"
import style0 from "./summary.vue?vue&type=style&index=0&id=0a16aafa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a16aafa",
  null
  
)

export default component.exports